const FilterByPrice = (props) => {
    const { selectedPriceRanges, handlePriceCheckboxChange, handleClearFilters, setIsSidebarVisible } = props;

    return (
        <div>
            <div className="widget sidebar-tags pt-sm-4">
                <div className="widget-title open">
                    <h3 className="sidebar-title text-uppercase">
                        <span>Shop by Price</span>
                    </h3>
                </div>
                <div className="widget-content d-block">
                    <ul className="list-tags p-0 list-unstyled">
                        {['0-399', '400-799', '800-1099', '1100-1999', '2000+'].map((range, i) => (
                            <li className="item" key={i}>
                                <input
                                    type="checkbox"
                                    value={range}
                                    checked={selectedPriceRanges.includes(range)}
                                    onChange={() => handlePriceCheckboxChange(range)}
                                />
                                <label>{range.replace('-', ' to ').replace('+', 'Above')}</label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="filter_buttons pt-2 d-flex align-items-center">
                <button onClick={handleClearFilters} className="filter_clear_button">Clear</button>
                <button onClick={() => setIsSidebarVisible(false)} className="filter_apply__button">Apply</button>
            </div>
        </div>
    )
}

export default FilterByPrice;